import { render, staticRenderFns } from "./vcLoading.vue?vue&type=template&id=5da3945c&scoped=true&"
import script from "./vcLoading.vue?vue&type=script&lang=js&"
export * from "./vcLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da3945c",
  null
  
)

export default component.exports